import React, { Component, PropTypes } from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { MenuItem, IconButton, FontIcon, IconMenu, Divider } from 'material-ui';
import ArchivedIcon from 'material-ui/svg-icons/content/archive';

import { getShownState } from '../../contractingUtils';
import { JiraFlatButton } from '../../../tc-ui/small-buttons';
import DownloadUploadButton from './downloadUploadButton';
import ContractMailbox from '../../generic-components/contractMailbox';
import ExportTourWriter from '../../generic-components/exportTourWriter';
import RequestDataLoadingIcon from 'material-ui/svg-icons/action/markunread-mailbox';
import WallWrapper from '../../../wall/wrapper';

const styles = StyleSheet.create({
  container: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' },
});

class ActionButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCopied: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(ActionButtons.propTypes).filter(key => ActionButtons.propTypes[key] !== ActionButtons.propTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  render() {
    const {
      actions,
      contract,
      disabled,
      goIntoContractOrWizard,
      // isFolder,
      // onClickDiscardRequestsSentToSameName,
      openManageFolderDialog,
      openMenu,
      resourceType,
      // routeName,
      style,
      templates,
      triggerNoAccessWarning,
      viewingBy,
      requestDataLoading,
    } = this.props;

    const shownState = getShownState({ companyType: viewingBy, ...contract });
    const inOutBox = R.contains(shownState, ['sending', 'bounced']);
    const readOnly = !R.contains('write', contract.access);
    const requestDL = () => requestDataLoading({ contractId: contract._id, files: contract.files });
    const resendContract = () => actions.openResendContractDialog({
      contractId: contract._id,
      to: contract.to,
      toEmails: contract.toEmails,
      resendToEmails: contract.toEmails,
    });
    const moveToTrash = readOnly ? triggerNoAccessWarning : () => actions.moveToTrash(contract._id);
    const moveToArchived = readOnly ? triggerNoAccessWarning : () => actions.moveToArchived(contract._id);
    if (contract.isDeleted) {
      return (
        <JiraFlatButton
          style={{ minWidth: '64px' }}
          labelStyle={{ padding: 0 }}
          label="Restore"
          onTouchTap={() => actions.restoreContract(contract._id)}
        />);
    }
    if (contract.isArchived) {
      return (
        <JiraFlatButton
          style={{ minWidth: '64px' }}
          labelStyle={{ padding: 0 }}
          label="Restore"
          onTouchTap={() => actions.restoreContractFromArchived(contract._id)}
        />);
    }
    return (
      <div className={`moreActions ${css(styles.container)}`} style={style} id={`moreActions-${contract._id}`}>
        <DownloadUploadButton
          disabled={disabled}
          contract={contract}
          templates={templates}
          downloadContractPdf={actions.downloadContractPdf}
          goIntoContractOrWizard={goIntoContractOrWizard}
        />
        <IconMenu
          iconButtonElement={<IconButton disabled={disabled} iconClassName="tc-icon-more-vert" style={{ paddingLeft: 0, width: '28px' }} iconStyle={{ color: '#616061' }} />}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onTouchTap={openMenu}
          onItemTouchTap={openMenu}
          desktop
        >
          {resourceType === 'Contractor'
          && !contract.locationId
          ? (
            <MenuItem
              primaryText="Submit this workspace for data loading"
              onTouchTap={requestDL}
              disabled={contract.state === 'loading' || contract.state === 'loaded' || contract.state === 'rejected' || contract.rateConversionSetting !== 'defer'}
              leftIcon={<RequestDataLoadingIcon color="rgba(0, 0, 0, 0.67)" />}
            />
          ) : <span/>}
          {contract.viewerIsSender ? (
            <MenuItem
              primaryText={`Resend`}
              onTouchTap={resendContract}
              leftIcon={<FontIcon className="tc-icon-near_me" color="rgba(0, 0, 0, 0.67)" />}
            />) : <span/>}
          { contract.viewerIsSender && <Divider /> }
          {!inOutBox && (
            <WallWrapper amazonOrange skipClick>
              <MenuItem
                leftIcon={<FontIcon className="tc-icon-create_new_folder" color="#00bcd4" />}
                primaryText="Assign Folders"
                onTouchTap={readOnly ? triggerNoAccessWarning : openManageFolderDialog('assign')}/>
            </WallWrapper>
          )}
          <MenuItem
            leftIcon={<FontIcon className="tc-icon-folder_open" />}
            disabled={!(contract.folders && contract.folders.length)}
            primaryText="Move Out of Folder"
            onTouchTap={openManageFolderDialog('moveOut')}
          />
          {!inOutBox && <Divider/>}
          <MenuItem leftIcon={<ArchivedIcon />} primaryText="Move to Archived" onTouchTap={moveToArchived}/>
          <MenuItem leftIcon={<FontIcon className="tc-icon-delete2" color="#ff4081" />} primaryText="Move to Trash" onTouchTap={moveToTrash}/>
          { resourceType === 'Contractor' && <Divider/> }
          {/*{*/}
          {/*  Boolean(contract.companyName) && resourceType === 'Contractor' && (*/}
          {/*    <MenuItem*/}
          {/*      primaryText={<span style={{ color: '#ff4081' }}>Discard outstanding requests sent to <b>{contract.companyName}</b> for {`${new Date(contract.startDate).getYear() - 100}-${new Date(contract.endDate).getYear() - 100}`}</span>}*/}
          {/*      onTouchTap={() => {*/}
          {/*        onClickDiscardRequestsSentToSameName({*/}
          {/*          contractPeriod: { startDate: contract.startDate, endDate: contract.endDate },*/}
          {/*          contractIdToExclude: contract._id,*/}
          {/*          searchCompanyName: contract.companyName,*/}
          {/*          searchDomain: '',*/}
          {/*        });*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  )*/}
          {/*}*/}
          {/*{*/}
          {/*  Boolean(contract.privateDomain && !contract.supplierId) && resourceType === 'Contractor' && (*/}
          {/*    <MenuItem*/}
          {/*      primaryText={<span style={{ color: '#ff4081' }}>Discard outstanding requests sent to <b>@{contract.domain}</b> for {`${new Date(contract.startDate).getYear() - 100}-${new Date(contract.endDate).getYear() - 100}`}</span>}*/}
          {/*      onTouchTap={() => {*/}
          {/*        onClickDiscardRequestsSentToSameName({*/}
          {/*          contractPeriod: { startDate: contract.startDate, endDate: contract.endDate },*/}
          {/*          contractIdToExclude: contract._id,*/}
          {/*          searchCompanyName: '',*/}
          {/*          searchDomain: `@${contract.domain}`,*/}
          {/*        });*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  )*/}
          {/*}*/}
          {/*<Divider />*/}
          <ContractMailbox contractId={contract._id} />
          <ExportTourWriter contractId={contract._id} />
          <ExportTourWriter contractId={contract._id} blackout />
        </IconMenu>
      </div>
    );
  }
}

ActionButtons.propTypes = {
  actions: PropTypes.object,
  contract: PropTypes.object,
  contractMailboxLoding: PropTypes.bool,
  contractMailboxMailbox: PropTypes.string,
  disabled: PropTypes.bool,
  folders: PropTypes.array,
  getContractForwardingEmail: PropTypes.func,
  goIntoContractOrWizard: PropTypes.func,
  isFolder: PropTypes.bool,
  onClickDiscardRequestsSentToSameName: PropTypes.func,
  openManageFolderDialog: PropTypes.func,
  openMenu: PropTypes.func,
  resourceType: PropTypes.string,
  routeName: PropTypes.string,
  searchCategory: PropTypes.string,
  style: PropTypes.object,
  templates: PropTypes.array,
  triggerNoAccessWarning: PropTypes.func,
  viewingBy: PropTypes.string,
  requestDataLoading: PropTypes.func,
};

const mapStateToProps = ({ contracting, user }) => ({
  folders: contracting.contractList.get('folders').toJS(),
  isFolder: contracting.contractList.get('isFolder'),
  resourceType: user.getIn(['user', 'type']),
  routeName: contracting.contractList.getIn(['list', 'listType']),
  searchCategory: contracting.contractList.get('searchCategory') || '',
  viewingBy: user.getIn(['user', 'type']),
});

export default connect(mapStateToProps, {
  onClickDiscardRequestsSentToSameName: payload => ({ type: 'OPEN_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME', payload }),
  requestDataLoading: payload => ({ type: 'OPEN_REQUEST_DL', payload }),
})(ActionButtons);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/list/action-buttons.jsx